import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Mail, CheckCircle2 } from 'lucide-react';
import { InputField } from '../components/InputField';
import { Button } from '../components/Button';
import { forgotPassword } from '../api/auth';
export function ForgotPassword() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      setError('Please enter a valid email');
      return;
    }
    setIsLoading(true);
    setError('');
    try {
      await forgotPassword(email);
      setIsSuccess(true);
    } catch (err: any) {
      setError(err.message || 'Failed to send reset link');
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen w-full bg-background md:bg-secondary flex flex-col items-center justify-center p-0 md:p-6 animate-fadeInUp" data-id="element-975" data-mp="3460ybhxtk7ve">
      <div className="w-full max-w-[480px] min-h-screen md:min-h-0 bg-background md:rounded-card md:shadow-elevated flex flex-col relative" data-id="element-976" data-mp="386kw8nq7vfil">
        <div className="p-6 pt-12 flex-1" data-id="element-977" data-mp="2u9xkvfxiomt5">
          <button onClick={() => navigate('/login')} className="mb-8 text-text-secondary hover:text-text-primary transition-colors" aria-label="Go back" data-id="element-978" data-mp="2z64ubip4ggfu">
            <ArrowLeft size={24} data-id="element-979" data-mp="2p903h5kbzwsp" />
          </button>

          {isSuccess ? <div className="flex flex-col items-center justify-center py-12 text-center animate-fadeInUp" data-id="element-980" data-mp="2bhlln225u1n8">
              <div className="w-16 h-16 bg-success/20 rounded-full flex items-center justify-center mb-6" data-id="element-981" data-mp="2gfwvvdwdae5z">
                <CheckCircle2 size={32} className="text-success" data-id="element-982" data-mp="21iw2l5yj2b5e" />
              </div>
              <h1 className="text-[24px] font-semibold text-text-primary mb-3" data-id="element-983" data-mp="26is6z6b504lh">
                Check your email
              </h1>
              <p className="text-[16px] text-text-secondary mb-8 max-w-[280px]" data-id="element-984" data-mp="1nef8arxy8iuj">
                We sent a password reset link to {email}
              </p>
              <Button onClick={() => navigate('/login')} variant="secondary" data-id="element-985" data-mp="1dnklnmgsjh8k">
                Return to Login
              </Button>
            </div> : <>
              <div className="mb-8" data-id="element-986" data-mp="18mwlobal3q27">
                <h1 className="text-[28px] font-semibold text-text-primary mb-2" data-id="element-987" data-mp="26crlqpvw8evx">
                  Reset Password
                </h1>
                <p className="text-[16px] text-text-secondary" data-id="element-988" data-mp="21e6hmfditb27">
                  We'll send a reset link to your email
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-989" data-mp="1rg0i24f6sh0i">
                <label htmlFor="email" className="sr-only" data-id="element-990" data-mp="kz58l5h7z8zv">
                  Email
                </label>
                <InputField id="email" name="email" type="email" placeholder="your@email.com" icon={<Mail size={20} data-id="element-992" data-mp="2rlcerfb9l9an" />} value={email} onChange={e => {
              setEmail(e.target.value);
              if (error) setError('');
            }} error={error} data-id="element-991" data-mp="g0btx9q75by4" />

                <Button type="submit" isLoading={isLoading} loadingText="Sending link..." data-id="element-993" data-mp="36d3ftsaehfga">
                  Send Reset Link
                </Button>
              </form>
            </>}
        </div>
      </div>
    </div>;
}